__turbopack_context__.v({
  "nav-articles-item": "_1UTkFa_nav-articles-item",
  "nav-articles-item-cotainer": "_1UTkFa_nav-articles-item-cotainer",
  "nav-articles-list": "_1UTkFa_nav-articles-list",
});
